import axios from '@/libs/axios'

export default {
  listUsers: params => axios.get('/admin/users', { params }),
  startImpersonation: userId => axios.post(`/admin/impersonation/${userId}`),
  revertImpersonation: () => axios.post('/admin/impersonation/revert'),
}
